const logs = {
    page_title: '审计日志',
    title: '审计日志',
    subtitle: '查看用户行为和事件',
    event: '事件',
    user: '用户',
    application: '应用',
    time: '时间',
    filter_by: '过滤',
    last_1_hour: '最近 1 小时',
    last_24_hours: '最近 24 小时',
    last_7_days: '最近 7 天',
    last_30_days: '最近 30 天',
    custom_range: '自定义范围',
    from: '从',
    to: '至',
};
export default Object.freeze(logs);
